/** Must match Tailwind `landscape` variant (`tailwind.config.js`) */
export const LANDSCAPE_BOTTOM_NAV_MEDIA = 'only screen and (max-height: 480px) and (max-width: 960px)'
